import { Divider, ListItemIcon, ListSubheader, MenuItem } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import paths from "../../../../api/paths.api";

import { adminPanelTabs } from "../../../../pages/admin/Panel/adminPanelTabs";

export default function AdminOptions({ handleClose }) {
  const navigate = useNavigate();

  const onClick = (id) => {
    navigate(paths.adminPanel + "/" + id);
  };

  return (
    <>
      <Divider />
      <ListSubheader>Admin Panel :</ListSubheader>

      {adminPanelTabs().map((tab) => {
        return (
          <MenuItem onClick={() => onClick(tab.id)} key={tab.id}>
            {" "}
            <ListItemIcon>{tab.icon}</ListItemIcon>
            {tab.label}
          </MenuItem>
        );
      })}
    </>
  );
}
